import type {GhaClassification} from './index'

/** The meta slice fields these selectors read, shared by search and checkout */
export interface State {
  meta: {
    ghaClassification?: GhaClassification | null
  }
}

/** `null` while the classification is unavailable, such as on a cached page */
export const getGhaClassification = (state: State): GhaClassification | null =>
  state.meta.ghaClassification ?? null

/**
 * A checker identified by either signal, the URL marker or the verifier user
 * agent. `false` while the classification is unavailable. Every consumer reads
 * this one flag, so neither signal splits behaviour between the applications.
 */
export const getIsGhaChecker = (state: State): boolean => {
  const classification = getGhaClassification(state)
  return classification !== null && classification !== 'regular'
}
